<template>
  <div class="analytics-dashboard-header-box">
    <div class="row">
      <div class="col-8">
        <h1>{{title}}</h1>
      </div>
      <div class="col-4">
        <slot name="filter" />
      </div>
    </div>
  </div>
</template>


<script>
export default {
  name: 'AnalyticsDashboardHeader',
  props: {
    title: String
  }
}
</script>